<script setup>
import { computed } from 'vue';

import icon01 from '@/assets/images/result/ai/icon_01.svg';
import icon02 from '@/assets/images/result/ai/icon_02.svg';
import icon03 from '@/assets/images/result/ai/icon_03.svg';
import icon04 from '@/assets/images/result/ai/icon_04.svg';

const icons = [icon01, icon02, icon03, icon04];

const props = defineProps({
  userRole: {
    type: String,
    default: 'student'
  },
  studentData: {
    type: Object,
    default: null
  }
});

// 학생 데이터 기반 댓글 매핑
const LEVEL_COMMENTS = {
  e: {
    a: {
      lev_high: '학생은 인공지능의 다양한 원리를 사례를 들어 설명할 수 있습니다. 데이터 기반 인공지능이 만들어지는 전체 과정을 탐색하고, 나아가 일상에서 필요한 데이터를 직접 수집하고 분석하는 통합적인 역량을 보여줍니다. 또한, 생성형 인공지능이 만든 결과물을 맹목적으로 수용하지 않고, 그것이 편향되거나 틀릴 수 있다는 사실을 인지하며 비판적으로 평가하는 성숙한 태도를 갖춘 수준입니다.',
      lev_mid: '학생은 인공지능의 기본 원리와 기계학습 같은 핵심 개념을 자신의 언어로 설명할 수 있습니다. 개념 이해에 그치지 않고, 기계학습 과정을 직접 체험하거나 생성형 인공지능을 활용해 결과물을 만들어보는 등 기술을 적극적으로 탐색하고 경험하려 합니다. 인공지능 기술이 무엇을 할 수 있는지 구체적으로 이해하고 활용법을 익히는 데 중점을 두는 수준입니다.',
      lev_low: '학생은 인공지능 기술에 대한 흥미와 호기심을 보이며 탐구를 시작하는 단계입니다. 주변에서 어떤 것이 인공지능 기술이고 아닌지를 구분할 수 있으며, 다양한 인공지능 사례를 찾아보며 기본적인 개념을 형성해 나갑니다. 기술의 원리보다는, 인공지능이 우리 생활과 어떻게 관련되어 있는지 관심을 갖고 탐색하려는 태도를 보이는 수준입니다.',
    },
    b: {
      lev_high: '학생은 AI·디지털 도구를 단순히 사용하는 것을 넘어, 학습 및 창작과 같은 구체적인 목적에 맞게 활용하고 그 과정과 결과를 비판적으로 평가할 수 있습니다. 학습 과정에서 중요한 결정을 내릴 때 인공지능이 제시한 정보를 그대로 수용하지 않고 검토하는 자세를 보입니다. 또한, 창작 활동에 AI·디지털 도구를 활용할 때 나타나는 장점과 단점을 명확히 비교하여 설명할 수 있는 등 기술의 명암을 균형 있게 이해하는 수준입니다.',
      lev_mid: '학생은 AI·디지털 도구를 활용하여 실생활 및 학습에서 마주하는 간단한 문제를 해결하고 구체적인 결과물을 만들어내는 경험을 할 수 있습니다. 문제 해결 과정을 스스로 탐색하고 실행할 수 있으며, 문자, 그림, 영상 등을 AI·디지털 도구로 직접 제작하는 체험을 즐깁니다. 다양한 도구를 사용해 보며 새로운 아이디어를 시도하는 등 기술에 대한 적극적인 태도를 보이는 수준입니다.',
      lev_low: '학생은 AI·디지털 도구가 우리 주변에서 어떻게 쓰이는지 발견하고 탐색하며 기본적인 호기심을 갖는 단계입니다. 일상생활이나 학습 상황에서 인공지능 기술이 문제 해결에 사용된 사례를 찾아볼 수 있고, 인공지능이 그림이나 음악 등 창작 활동에 활용된 사례를 찾아 설명할 수 있습니다. ',
    },
    c: {
      lev_high: '학생은 AI·디지털 윤리 원칙을 내면화하여 책임감 있는 태도로 기술을 사용합니다. 개인정보 데이터를 안전하게 관리하고 보호하려는 태도를 꾸준히 보이며, 타인의 창작물을 존중하며 인공지능을 책임감 있게 사용하려는 자세를 갖추고 있습니다. 여기서 더 나아가 AI·디지털 기술이 사회에 주는 이로움과 해로움을 스스로 파악하려는 비판적 자세를 지닙니다.',
      lev_mid: '학생은 윤리적 개념 이해를 넘어 안전하고 책임감 있는 사용법을 직접 탐색하고 실천할 수 있습니다. 인공지능 과의존, 저작권 침해, 딥페이크와 같은 구체적인 윤리 문제에 대응하여 안전한 사용법을 탐색하고 실천합니다. 또한, 타인의 안전과 저작권 보호 등 책임감 있는 사용법을 적극적으로 탐색할 수 있으며, 인공지능이 사회에 미치는 영향을 스스로 조사할 수 있습니다.',
      lev_low: '학생은 AI·디지털 윤리의 기본적인 규칙을 이해하고 설명할 수 있습니다. 인공지능을 안전하게 사용하기 위한 기본 규칙과 개인정보 보호의 중요성을 설명할 수 있고, 저작권 및 타인의 안전을 보호하는 등 책임감 있는 사용법이 무엇인지 말할 수 있습니다. 인공지능이 우리에게 어떤 도움을 주는지, 미래에는 어떻게 발전할지에 대해 관심을 갖는 수준입니다.',
    },
    d: {
      lev_high: '학생은 인공지능을 더 나은 사회를 만드는 협업의 대상으로 인식하고, 문제 해결 과정에 주체적으로 참여하려는 태도를 갖습니다. 지속 가능한 사회 발전을 위해 인공지능 시스템으로 문제를 해결하는 과정에 적극적으로 참여하는 태도를 보입니다. 또한, 인공지능을 새로운 협업 파트너로 여기며 올바르게 협업하는 자세를 갖추고 있습니다.',
      lev_mid: '학생은 인공지능의 역할을 파악하고 분석하여 새로운 아이디어를 만들고 표현할 수 있습니다. 지속 가능한 사회 발전을 위해 인공지능이 어떻게 활용되는지 파악하고, 이를 바탕으로 다양한 아이디어를 내어 간단한 모형으로 표현할 수 있습니다. 나아가 인간과 인공지능이 주변을 인식하고 학습하는 방식을 비교하고 분석할 수 있으며, 일상생활 속에서 AI로 해결할 수 있는 문제를 스스로 정의할 수 있습니다.',
      lev_low: '학생은 우리 생활 속에서 인공지능의 쓰임새와 역할을 발견하고 탐색할 수 있습니다. 우리 주변에서 인공지능이 잘하는 일을 발견할 수 있고, 지속 가능한 사회의 발전을 위해 인공지능이 활용된 사례를 찾아볼 수 있습니다.',
    }
  },
  m: {
    a: {
      lev_high: '학생은 AI·디지털 기술 개발에 필요한 데이터를 주도적으로 다루고, 간단한 기계학습 모델을 직접 구현할 수 있습니다. 다양한 데이터 유형의 특성을 비교하고, 데이터를 목적에 맞게 구조화하거나 시각화할 수 있습니다. 데이터 수집부터 학습, 예측에 이르는 전 과정을 거쳐 간단한 기계학습 모델을 만들 수 있습니다. 특히 학습 데이터의 편향이 결과에 미치는 영향을 깊이 인식하고, 데이터 수집 및 활용 전반에 걸쳐 책임감 있는 태도를 보입니다. 생성형 AI가 만든 결과물도 비판적으로 검토하여 편향이나 오류를 찾아내는 등 기술에 대한 높은 수준의 책임 의식을 갖춘 수준입니다.',
      lev_mid: '학생은 AI의 핵심 기술인 기계학습의 주요 개념과 유형을 명확히 설명할 수 있습니다. 데이터가 기계학습에 왜 중요한지 이해하고, 데이터 수집 및 분석 과정을 단계별로 설명할 수 있습니다. 지도학습, 비지도학습, 강화학습과 같은 기계학습의 여러 유형을 구분하여 설명할 수 있습니다. 또한, 생성형 AI의 개념과 기본 원리를 이해하고 다른 AI와의 차이점을 설명할 수 있으며, 이를 활용하여 텍스트나 이미지 같은 결과물을 만들고 그 특징을 설명할 수 있습니다.',
      lev_low: '학생은 인공지능의 기본적인 개념과 역할을 이해하고, 구체적인 사례와 연결지을 수 있습니다. 인공지능이 무엇인지 알고 그 특징과 주요 원리를 열거할 수 있으며 , 예측, 분석, 추천, 생성 등 인공지능이 하는 일을 실제 사례를 통해 구별할 수 있습니다. 인공지능의 필요성을 인식하고, 다양한 사례에 담긴 원리를 탐구하려는 호기심과 태도를 갖춘 수준입니다.',
    },
    b: {
      lev_high: '학생은 AI·디지털 도구를 비판적이고 책임감 있는 태도로 활용하며, 타인과 협력하여 문제를 해결합니다. AI·디지털도구로 문제를 해결하는 과정에서 다양한 관점을 시도하고 다른 사람과 협력하며 새로운 기술에 유연하게 적응하는 태도를 갖습니다. 창작에 AI를 활용할 때 올바른 사용법을 이해하고, 결과물의 신뢰성과 적절성을 스스로 평가할 수 있습니다. 또한, AI로 만든 창작물은 그 사실을 명확히 표시하고 저작권을 존중하는 등 책임감 있는 태도를 보입니다. 학습 상황에서는 도구에 의존하지 않고 자신의 주체성이 보장되어야 함을 이해하며 올바른 활용 습관을 갖춥니다.',
      lev_mid: '학생은 AI·디지털 도구를 실제 문제 해결 및 창작 활동에 적극적으로 적용할 수 있습니다. 실생활의 문제를 해결하기 위해 적절한 AI·디지털도구를 직접 선택하고 활용하여 문제를 해결할 수 있습니다. AI·디지털 도구를 사용하여 문자, 그림, 영상 등을 창의적으로 제작할 수 있으며, 학습 과정에서 AI·디지털 도구가 자신에게 구체적으로 어떤 도움을 주었는지 타당한 이유를 들어 설명할 수 있습니다.',
      lev_low: '학생은 AI·디지털 도구의 기능과 활용 사례를 이해하고 설명할 수 있습니다. 일상생활과 여러 산업 분야에서 AI 도구가 문제 해결에 활용된 융합 사례를 탐색할 수 있습니다. 문자나 영상 등을 만드는 AI·디지털 도구의 주요 기능과 특징을 설명할 수 있으며, 이 도구들을 이용해 결과물을 만드는 절차와 방법 또한 설명할 수 있습니다. 학습 상황에서 AI·디지털 도구를 활용하여 해결할 수 있는 문제를 찾아 설명하는 것이 가능합니다',
    },
    c: {
      lev_high: '학생은 AI·디지털 윤리 원칙을 내면화하여 비판적이고 주도적인 자세로 윤리적 문제를 해결하려 합니다. 인공지능이 내놓은 결과를 그대로 수용하지 않고 비판적으로 검토하며, 그 안에 담긴 편향을 제거하려는 태도를 보입니다. AI·디지털기술이 사회에 미치는 자신과 타인, 사회에 미치는 영향력을 인지하며 사용하고, 자신과 타인의 개인정보 및 프라이버시를 존중하는 태도를 갖습니다. 나아가 AI·디지털윤리 문제를 해결하려는 적극적인 태도를 갖습니다.',
      lev_mid: '학생은 AI 기술 사용 시 발생할 수 있는 구체적인 윤리 문제를 식별하고 해결 방안을 탐색 및 실천할 수 있습니다. 개인정보 침해나 사생활 노출 같은 위험을 식별하고 이를 예방하는 방법을 실천할 수 있습니다. 규정 준수나 다양성 존중 등 AI를 책임감 있게 사용하는 방법을 탐색하고 실천합니다. 또한, 데이터 소유권 보호나 개인정보 보호와 같이 AI와 관련된 윤리적 딜레마를 발견하고, 그 딜레마의 주된 원인을 찾아낼 수 있습니다.',
      lev_low: '학생은 AI 기술과 관련된 기초적인 윤리 개념과 사회적 영향을 이해하고 설명할 수 있습니다. 딥페이크, 가짜 뉴스와 같은 기술 오남용의 위험성을 설명할 수 있으며, AI 적용 사례의 긍정적, 부정적 영향을 이해합니다. 편향성, 공정성, 신뢰성과 같은 AI 윤리 원칙을 이해하고 설명할 수 있습니다. AI로 인해 변화가 예상되는 미래 생활 모습을 설명할 수 있으며, AI 관련 직업에 관심을 보입니다.',
    },
    d: {
      lev_high: '학생은 인공지능을 인류의 가치에 부합하도록 설계하고, 주체적으로 협업하는 자세를 갖습니다. 지속 가능한 사회 발전을 위해 인공지능을 통해 인류 공통의 가치를 발견하고, 이를 기반으로 인간 중심의 AI를 설계한 뒤 비판적으로 평가하고 개선하는 태도를 보입니다. 또한, 인공지능을 단순한 도구가 아닌 새로운 협업의 대상으로 인식하며, AI 개발 및 활용 전반에 걸친 인간의 주체적이고 책임감 있는 역할을 탐색하는 성숙한 자세를 갖춥니다.',
      lev_mid: '학생은 AI 원리를 바탕으로 사회 문제를 정의하고, 협업을 통해 창의적인 해결책을 구체화할 수 있습니다. 인간을 이롭게 하기 위해 AI 원리를 이해하고, 이를 바탕으로 AI로 해결 가능한 문제를 정의할 수 있습니다. 다른 사람들과의 협업을 통해 지속 가능한 사회 발전을 위한 AI 활용법을 창의적으로 구상하고, 이를 프로토타입으로 만들어 실제 상황에 적용할 수 있습니다.',
      lev_low: '학생은 인간과 인공지능의 관계를 이해하고, 각각의 역할과 특징을 비교하여 설명할 수 있습니다. 지속 가능한 사회 발전을 위한 AI 활용 사례에서 인공지능이 어떤 역할을 하는지 설명할 수 있습니다. 인간 지능과 인공지능의 공통점과 차이점을 비교할 수 있으며, 다양한 영역에서 인간이 잘하는 일과 인공지능이 잘하는 일을 비교 분석할 수 있습니다.',
    }
  }
};

// 기본 콘텐츠 (학생 데이터가 없을 때 사용)
const DEFAULT_CONTENT = [
  { title: 'AI·디지털 기술', content: '학생은 인공지능의 기본 원리와 기계학습 같은 핵심 개념을 자신의 언어로 설명할 수 있습니다.' },
  { title: 'AI·디지털 활용', content: '학생은 AI·디지털 도구를 활용하여 실생활 및 학습에서 마주하는 간단한 문제를 해결할 수 있습니다.' },
  { title: 'AI·디지털 윤리', content: '학생은 윤리적 개념 이해를 넘어 안전하고 책임감 있는 사용법을 직접 탐색하고 실천할 수 있습니다.' },
  { title: '인간 중심 AI', content: '학생은 인공지능의 역할을 파악하고 분석하여 새로운 아이디어를 만들고 표현할 수 있습니다.' }
];

const displayRows = computed(() => {
  if (!props.studentData) {
    return DEFAULT_CONTENT;
  }

  const schulType = (props.studentData.schul_type || 'e').toLowerCase();
  const fieldLevels = [
    props.studentData.field1_level,
    props.studentData.field2_level,
    props.studentData.field3_level,
    props.studentData.field4_level
  ];
  const codes = ['a', 'b', 'c', 'd'];
  const titles = ['AI·디지털 기술', 'AI·디지털 활용', 'AI·디지털 윤리', '인간 중심 AI 설계'];

  // 한글 레벨을 영어 레벨로 변환
  const levelMapping = {
    '상': 'lev_high',
    '중': 'lev_mid', 
    '하': 'lev_low'
  };

  return titles.map((title, index) => {
    const code = codes[index];
    const rawLevel = fieldLevels[index];
    const level = levelMapping[rawLevel] || 'lev_mid'; // 기본값은 중간 레벨
    const content = LEVEL_COMMENTS[schulType]?.[code]?.[level] || DEFAULT_CONTENT[index].content;
    
    return { title, content };
  });
});
</script>

<template>
  <div class="card area-guide pt-5">        
    <div class="ai-table primary">
      <div class="row thead">
        <div class="th">영역</div>
        <div class="td">영역별 성취 설명</div>
      </div>
      <div class="row" v-for="(row, index) in displayRows" :key="index">
        <div class="th">
          <img :src="icons[index]" alt="icon">
          <p v-html="row.title"></p>
        </div>
        <div class="td">{{ row.content }}</div>
      </div>
    </div>    
  </div>
</template>

<style lang="scss" scoped>
    .report-inner .ai-table {
      border-bottom: 0;
      .row {
        &.thead > div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        > div {      
          &.th { 
            flex-direction: column;
            p { font-size: 1.125rem; font-weight: 600; color: var(--result-ai-primary-800); }
          }      
          &.td {
            line-height: 1.6;
            text-align: justify;
            word-break: keep-all;
            text-justify: inter-word;
            display: flex;
            align-items: center;
          }      
        }
      }
    } 
</style>